/* tslint:disable */
/* eslint-disable */
/**
 * Indices API
 * Référentiel des indices de branche et de leurs valeurs datées
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AjouterValeurIndiceCommand,
  CreateIndiceCommand,
  ErrorResponse,
  IndiceDto,
  OperationResponse,
  RattacherBranchesIndiceCommand,
  SearchIndicesCommand,
  SearchIndicesResponse,
  UpdateIndiceCommand,
} from '../models/index';
import {
    AjouterValeurIndiceCommandFromJSON,
    AjouterValeurIndiceCommandToJSON,
    CreateIndiceCommandFromJSON,
    CreateIndiceCommandToJSON,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    IndiceDtoFromJSON,
    IndiceDtoToJSON,
    OperationResponseFromJSON,
    OperationResponseToJSON,
    RattacherBranchesIndiceCommandFromJSON,
    RattacherBranchesIndiceCommandToJSON,
    SearchIndicesCommandFromJSON,
    SearchIndicesCommandToJSON,
    SearchIndicesResponseFromJSON,
    SearchIndicesResponseToJSON,
    UpdateIndiceCommandFromJSON,
    UpdateIndiceCommandToJSON,
} from '../models/index';

export interface AddIndiceValueRequest {
    indiceId: string;
    ajouterValeurIndiceCommand: AjouterValeurIndiceCommand;
}

export interface CreateIndiceRequest {
    createIndiceCommand: CreateIndiceCommand;
}

export interface DeleteIndiceRequest {
    indiceId: string;
}

export interface DeleteIndiceValueRequest {
    indiceId: string;
    valeurId: string;
}

export interface GetIndiceRequest {
    indiceId: string;
}

export interface GetIndicesByBranchRequest {
    brancheId: string;
}

export interface SearchIndicesRequest {
    searchIndicesCommand: SearchIndicesCommand;
}

export interface SetIndiceBranchesRequest {
    indiceId: string;
    rattacherBranchesIndiceCommand: RattacherBranchesIndiceCommand;
}

export interface UpdateIndiceRequest {
    indiceId: string;
    updateIndiceCommand: UpdateIndiceCommand;
}

/**
 * 
 */
export class IndicesApi extends runtime.BaseAPI {

    /**
     * Ajouter une valeur à un indice
     */
    async addIndiceValueRaw(requestParameters: AddIndiceValueRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OperationResponse>> {
        if (requestParameters['indiceId'] == null) {
            throw new runtime.RequiredError(
                'indiceId',
                'Required parameter "indiceId" was null or undefined when calling addIndiceValue().'
            );
        }

        if (requestParameters['ajouterValeurIndiceCommand'] == null) {
            throw new runtime.RequiredError(
                'ajouterValeurIndiceCommand',
                'Required parameter "ajouterValeurIndiceCommand" was null or undefined when calling addIndiceValue().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/referentiel/indices/{indiceId}/valeurs`.replace(`{${"indiceId"}}`, encodeURIComponent(String(requestParameters['indiceId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AjouterValeurIndiceCommandToJSON(requestParameters['ajouterValeurIndiceCommand']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OperationResponseFromJSON(jsonValue));
    }

    /**
     * Ajouter une valeur à un indice
     */
    async addIndiceValue(requestParameters: AddIndiceValueRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OperationResponse> {
        const response = await this.addIndiceValueRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Créer un indice
     */
    async createIndiceRaw(requestParameters: CreateIndiceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OperationResponse>> {
        if (requestParameters['createIndiceCommand'] == null) {
            throw new runtime.RequiredError(
                'createIndiceCommand',
                'Required parameter "createIndiceCommand" was null or undefined when calling createIndice().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/referentiel/indices`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateIndiceCommandToJSON(requestParameters['createIndiceCommand']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OperationResponseFromJSON(jsonValue));
    }

    /**
     * Créer un indice
     */
    async createIndice(requestParameters: CreateIndiceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OperationResponse> {
        const response = await this.createIndiceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Supprimer un indice
     */
    async deleteIndiceRaw(requestParameters: DeleteIndiceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OperationResponse>> {
        if (requestParameters['indiceId'] == null) {
            throw new runtime.RequiredError(
                'indiceId',
                'Required parameter "indiceId" was null or undefined when calling deleteIndice().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/referentiel/indices/{indiceId}`.replace(`{${"indiceId"}}`, encodeURIComponent(String(requestParameters['indiceId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OperationResponseFromJSON(jsonValue));
    }

    /**
     * Supprimer un indice
     */
    async deleteIndice(requestParameters: DeleteIndiceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OperationResponse> {
        const response = await this.deleteIndiceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Supprimer une valeur d\'indice
     */
    async deleteIndiceValueRaw(requestParameters: DeleteIndiceValueRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OperationResponse>> {
        if (requestParameters['indiceId'] == null) {
            throw new runtime.RequiredError(
                'indiceId',
                'Required parameter "indiceId" was null or undefined when calling deleteIndiceValue().'
            );
        }

        if (requestParameters['valeurId'] == null) {
            throw new runtime.RequiredError(
                'valeurId',
                'Required parameter "valeurId" was null or undefined when calling deleteIndiceValue().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/referentiel/indices/{indiceId}/valeurs/{valeurId}`.replace(`{${"indiceId"}}`, encodeURIComponent(String(requestParameters['indiceId']))).replace(`{${"valeurId"}}`, encodeURIComponent(String(requestParameters['valeurId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OperationResponseFromJSON(jsonValue));
    }

    /**
     * Supprimer une valeur d\'indice
     */
    async deleteIndiceValue(requestParameters: DeleteIndiceValueRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OperationResponse> {
        const response = await this.deleteIndiceValueRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Détail d\'un indice
     */
    async getIndiceRaw(requestParameters: GetIndiceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IndiceDto>> {
        if (requestParameters['indiceId'] == null) {
            throw new runtime.RequiredError(
                'indiceId',
                'Required parameter "indiceId" was null or undefined when calling getIndice().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/referentiel/indices/{indiceId}`.replace(`{${"indiceId"}}`, encodeURIComponent(String(requestParameters['indiceId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IndiceDtoFromJSON(jsonValue));
    }

    /**
     * Détail d\'un indice
     */
    async getIndice(requestParameters: GetIndiceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IndiceDto> {
        const response = await this.getIndiceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Indices d\'une branche
     */
    async getIndicesByBranchRaw(requestParameters: GetIndicesByBranchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IndiceDto>>> {
        if (requestParameters['brancheId'] == null) {
            throw new runtime.RequiredError(
                'brancheId',
                'Required parameter "brancheId" was null or undefined when calling getIndicesByBranch().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/referentiel/indices/branches/{brancheId}`.replace(`{${"brancheId"}}`, encodeURIComponent(String(requestParameters['brancheId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(IndiceDtoFromJSON));
    }

    /**
     * Indices d\'une branche
     */
    async getIndicesByBranch(requestParameters: GetIndicesByBranchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IndiceDto>> {
        const response = await this.getIndicesByBranchRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Rechercher des indices
     */
    async searchIndicesRaw(requestParameters: SearchIndicesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SearchIndicesResponse>> {
        if (requestParameters['searchIndicesCommand'] == null) {
            throw new runtime.RequiredError(
                'searchIndicesCommand',
                'Required parameter "searchIndicesCommand" was null or undefined when calling searchIndices().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/referentiel/indices/liste`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SearchIndicesCommandToJSON(requestParameters['searchIndicesCommand']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SearchIndicesResponseFromJSON(jsonValue));
    }

    /**
     * Rechercher des indices
     */
    async searchIndices(requestParameters: SearchIndicesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SearchIndicesResponse> {
        const response = await this.searchIndicesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Rattacher un indice à des branches
     */
    async setIndiceBranchesRaw(requestParameters: SetIndiceBranchesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OperationResponse>> {
        if (requestParameters['indiceId'] == null) {
            throw new runtime.RequiredError(
                'indiceId',
                'Required parameter "indiceId" was null or undefined when calling setIndiceBranches().'
            );
        }

        if (requestParameters['rattacherBranchesIndiceCommand'] == null) {
            throw new runtime.RequiredError(
                'rattacherBranchesIndiceCommand',
                'Required parameter "rattacherBranchesIndiceCommand" was null or undefined when calling setIndiceBranches().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/referentiel/indices/{indiceId}/branches`.replace(`{${"indiceId"}}`, encodeURIComponent(String(requestParameters['indiceId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: RattacherBranchesIndiceCommandToJSON(requestParameters['rattacherBranchesIndiceCommand']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OperationResponseFromJSON(jsonValue));
    }

    /**
     * Rattacher un indice à des branches
     */
    async setIndiceBranches(requestParameters: SetIndiceBranchesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OperationResponse> {
        const response = await this.setIndiceBranchesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Modifier un indice
     */
    async updateIndiceRaw(requestParameters: UpdateIndiceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OperationResponse>> {
        if (requestParameters['indiceId'] == null) {
            throw new runtime.RequiredError(
                'indiceId',
                'Required parameter "indiceId" was null or undefined when calling updateIndice().'
            );
        }

        if (requestParameters['updateIndiceCommand'] == null) {
            throw new runtime.RequiredError(
                'updateIndiceCommand',
                'Required parameter "updateIndiceCommand" was null or undefined when calling updateIndice().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/referentiel/indices/{indiceId}`.replace(`{${"indiceId"}}`, encodeURIComponent(String(requestParameters['indiceId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateIndiceCommandToJSON(requestParameters['updateIndiceCommand']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OperationResponseFromJSON(jsonValue));
    }

    /**
     * Modifier un indice
     */
    async updateIndice(requestParameters: UpdateIndiceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OperationResponse> {
        const response = await this.updateIndiceRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
